const PREFIX_URL: string = 'https://platform.rekpo.ai' // Replace with your actual API URL
//const PREFIX_URL: string = 'http://127.0.0.1:8000'

export default PREFIX_URL
